function hasConsoleQueryParam() {
  if (typeof window === 'undefined' || !window.location) {
    return false;
  }

  return window.location.search
    .replace(/^\?/, '')
    .split('&')
    .some(pair => pair.split('=')[0] === 'console');
}

export function isDebugOn() {
  return hasConsoleQueryParam() || process.env.NODE_ENV === 'development';
}

function info(...args) {
  if (isDebugOn()) {
    console.info(...args); // eslint-disable-line no-console
  }
}

function warn(...args) {
  if (isDebugOn()) {
    console.warn(...args); // eslint-disable-line no-console
  }
}

function error(...args) {
  if (isDebugOn()) {
    console.error(...args); // eslint-disable-line no-console
  }
}

export default {
  info,
  warn,
  error,
};



// WEBPACK FOOTER //
// ./src/logger.js